import { usePermissions } from '@/features/auth';
import { buildDealerNameMap, useDealersByIds } from '@/features/dealers/hooks/useDealersByIds';
import type { DocumentTemplateSummary } from '../types/documentTemplates.types';
import { ownerLabel } from '../utils/templateOwnership';

/** The owner's display name, or null while the dealer name is still loading. */
export function useTemplateOwnerName(template: Pick<DocumentTemplateSummary, 'ownerDealerId'>): string | null {
  const { hasPermission } = usePermissions();
  const dealerIds = template.ownerDealerId === null ? [] : [template.ownerDealerId];
  const dealersQuery = useDealersByIds(dealerIds, hasPermission({ resource: 'dealer', action: 'browse' }));
  if (dealersQuery.isLoading) return null;
  return ownerLabel(template, buildDealerNameMap(dealersQuery.data));
}
